// extracted by mini-css-extract-plugin
module.exports = {"count-number":"styles-module__count-number___3n1S4","progress-bar-background":"styles-module__progress-bar-background___680yn"};